import React from 'react';
import { motion } from 'framer-motion';
import { Target, Zap, Salad, Shield, Calendar, MessageCircle } from 'lucide-react';
interface Bono {
  icon: React.ReactNode;
  shortTitle: string;
  title: string;
  desc: string;
  cover: string;
}
export function Bonos() {
  const bonos: Bono[] = [{
    icon: <Target className="w-7 h-7 text-white" data-id="element-22" />,
    shortTitle: 'Bonus 1',
    title: '🎯 Bonus 1 — NiveLómetro 360',
    desc: 'Detectá el nivel real de tu grupo en 20 minutos. Nunca más planificás a ciegas desde el primer día.',
    cover: 'bg-f360-green'
  }, {
    icon: <Zap className="w-7 h-7 text-white" data-id="element-23" />,
    shortTitle: 'Bonus 2',
    title: '⚡ Bonus 2 — Físico Express',
    desc: '12 bloques de activación listos para usar. Elegís en 30 segundos cuál corresponde según el grupo y el día.',
    cover: 'bg-orange-500'
  }, {
    icon: <Salad className="w-7 h-7 text-white" data-id="element-24" />,
    shortTitle: 'Bonus 3',
    title: '🥗 Bonus 3 — Nutrición y Rendimiento',
    desc: 'Guía práctica de alimentación e hidratación para que tus jugadores rindan mejor. Lista para compartir con familias.',
    cover: 'bg-emerald-600'
  }, {
    icon: <Shield className="w-7 h-7 text-white" data-id="element-25" />,
    shortTitle: 'Bonus 4',
    title: '🛡️ Bonus 4 — Kit de Supervivencia del Profe',
    desc: 'Qué hacer cuando falta gente, el grupo se desordena o la cancha se complica. Scripts listos para cada situación.',
    cover: 'bg-blue-600'
  }, {
    icon: <Calendar className="w-7 h-7 text-white" data-id="element-26" />,
    shortTitle: 'Bonus 5',
    title: '📅 Bonus 5 — Pack de Organización Semanal',
    desc: 'Planificá toda tu semana en una sola hoja en 10 minutos. Llega a cada sesión con la cabeza despejada.',
    cover: 'bg-f360-dark'
  }, {
    icon: <MessageCircle className="w-7 h-7 text-white" data-id="element-27" />,
    shortTitle: 'Bonus 6',
    title: '💬 Bonus 6 — 50 Frases del Profe',
    desc: 'Las frases exactas para ordenar, corregir y liderar la cancha sin gritar. Clasificadas por situación y listas para usar mañana.',
    cover: 'bg-red-600'
  }];
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-white" data-id="element-28">
      <div className="max-w-content mx-auto" data-id="element-29">
        <div className="text-center mb-16" data-id="element-30">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-31">
            <h2 className="text-4xl sm:text-5xl font-extrabold text-gray-900 mb-4" data-id="element-32">
              + 6 Regalos Estratégicos
            </h2>
            <p className="text-lg text-gray-600 font-medium mb-6" data-id="element-33">
              Incluidos sin costo extra · Valor real del pack
            </p>
            <div className="inline-block py-3 px-8 rounded-full bg-f360-gold text-f360-dark font-black tracking-wide uppercase shadow-md" data-id="element-34">
              🎁 GRATIS POR EL DÍA DE HOY
            </div>
          </motion.div>
        </div>

        <div className="grid sm:grid-cols-2 gap-8" data-id="element-35">
          {bonos.map((bono, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index % 2 * 0.1
        }} className="bg-white rounded-3xl p-8 border border-gray-200 shadow-sm hover:shadow-lg transition-shadow flex flex-col items-center text-center" data-id="element-36">
              {/* Book cover */}
              <div className="mb-7" data-id="element-37">
                <div className={`relative w-44 h-60 rounded-xl ${bono.cover} shadow-xl flex flex-col justify-between p-5 overflow-hidden`} data-id="element-38">
                  {/* Spine */}
                  <div className="absolute top-0 left-0 h-full w-3 bg-black/15" data-id="element-39" />
                  <div className="pl-2" data-id="element-40">{bono.icon}</div>
                  <div className="pl-2" data-id="element-41">
                    <p className="text-white text-xl font-black leading-tight" data-id="element-42">
                      {bono.shortTitle}
                    </p>
                    <div className="h-px bg-white/30 my-3" data-id="element-43" />
                    <p className="text-white/80 text-xs font-bold tracking-widest uppercase" data-id="element-44">
                      FÚTBOL 360™
                    </p>
                  </div>
                </div>
              </div>

              {/* GRATIS pill */}
              <span className="inline-block bg-green-100 text-f360-green text-sm font-black tracking-wide uppercase px-5 py-1.5 rounded-full mb-5" data-id="element-45">
                GRATIS
              </span>

              <h4 className="text-xl font-bold text-gray-900 mb-3 leading-snug" data-id="element-46">
                {bono.title}
              </h4>
              <p className="text-gray-600 leading-relaxed" data-id="element-47">{bono.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}